import { render } from "./DeleteBulkCampaignAction.vue?vue&type=template&id=033d1149"
import script from "./DeleteBulkCampaignAction.vue?vue&type=script&lang=ts"
export * from "./DeleteBulkCampaignAction.vue?vue&type=script&lang=ts"
script.render = render

export default script